/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";
import Info from "components/Typography/Info.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <p className={classes.left}>
          <span>
          <Info>
          Stay Home , Stay Safe.
          </Info>
          </span>
        </p>
        <p className={classes.right}>
          <Info>
          <span>
            Designed & Developed By : 
            <a
              href="https://piyushrajput.netlify.app"
              target="_blank"
              className={classes.a}
            >
              Piyush Rajput
            </a>
          </span>
          </Info>
        </p>
      </div>
    </footer>
  );
}
